type HistoryMethodArgs = [data: any, unused: string, url?: string | URL | null];

export function observeSpaNavigation(callback: (path: string) => void) {
  const updateTitle = () => callback(window.location.pathname);

  const wrapHistoryMethod = (type: "pushState" | "replaceState") => {
    const original = window.history[type] as (
      ...args: HistoryMethodArgs
    ) => any;

    return function (this: History, ...args: HistoryMethodArgs) {
      const result = original.apply(this, args);
      const event = new Event(type);
      window.dispatchEvent(event);
      return result;
    };
  };

  window.history.pushState = wrapHistoryMethod("pushState");
  window.history.replaceState = wrapHistoryMethod("replaceState");

  window.addEventListener("popstate", updateTitle);
  window.addEventListener("pushState", updateTitle);
  window.addEventListener("replaceState", updateTitle);

  updateTitle();

  return () => {
    window.removeEventListener("popstate", updateTitle);
    window.removeEventListener("pushState", updateTitle);
    window.removeEventListener("replaceState", updateTitle);
  };
}
